/**
 * Shared utility for mapping step names to Vietnamese translations
 * Used across ReworkBadge and ErrorWarningIcon components
 */

export const getStepName = (stepKey: string): string => {
  const stepNameMap: Record<string, string> = {
    'waiting_print_check': 'QC In',
    'waiting_laminate': 'Cán Màng',
    'waiting_delivery': 'Giao Hàng',
    'waiting_cut': 'Cắt',
    'waiting_print': 'In',
    'unknown': 'Không rõ',
  };

  return stepNameMap[stepKey] || stepKey;
};

export const stepNameMap: Record<string, string> = {
  'waiting_print_check': 'QC In',
  'waiting_laminate': 'Cán Màng',
  'waiting_delivery': 'Giao Hàng',
  'waiting_cut': 'Cắt',
  'waiting_print': 'In',
  'unknown': 'Không rõ',
};
